<div [ngStyle]="mapDivStyle()">
<div class='lgr_col'>
  <div class='lgr_10 col_01'><dynamic-field [id]='"scrndt2"' [size]=10 [line]=1 [column]=1 [(ngModel)]='scrndt2'></dynamic-field></div>
  <div class='lgr_40 col_20'><span class='brt high default' id='text1'>NATIONAL RAILROAD  PASSENGER CORPORATION</span>  </div>
  <div class='lgr_05 col_72'><span class='default' id='text2'>S145G</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_08 col_01'><dynamic-field [id]='"scrntm2"' [size]=8 [line]=2 [column]=1 [(ngModel)]='scrntm2'></dynamic-field></div>
  <div class='lgr_32 col_24'><span class='brt high default' id='text3'>NEW JERSEY TRANSIT - SURVEY DATA</span>  </div>
  <div class='lgr_02 col_72'><dynamic-field [id]='"pagenbr"' [size]=2 [line]=2 [column]=72 [(ngModel)]='pagenbr'></dynamic-field></div>
  <div class='lgr_02 col_75'><span class='default' id='text4'>OF</span>  </div>
  <div class='lgr_02 col_78'><dynamic-field [id]='"pagecnt"' [size]=2 [line]=2 [column]=78 [(ngModel)]='pagecnt'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_40 col_20'><span class='brt high default' id='text5'>----------------------------------------</span>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"head01"' [size]=79 [line]=5 [column]=1 [(ngModel)]='head01'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"head02"' [size]=79 [line]=6 [column]=1 [(ngModel)]='head02'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"line01"' [size]=79 [line]=7 [column]=1 [(ngModel)]='line01'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"line02"' [size]=79 [line]=8 [column]=1 [(ngModel)]='line02'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"line03"' [size]=79 [line]=9 [column]=1 [(ngModel)]='line03'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"line04"' [size]=79 [line]=10 [column]=1 [(ngModel)]='line04'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"line05"' [size]=79 [line]=11 [column]=1 [(ngModel)]='line05'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"line06"' [size]=79 [line]=12 [column]=1 [(ngModel)]='line06'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"line07"' [size]=79 [line]=13 [column]=1 [(ngModel)]='line07'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"line08"' [size]=79 [line]=14 [column]=1 [(ngModel)]='line08'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"line09"' [size]=79 [line]=15 [column]=1 [(ngModel)]='line09'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"line10"' [size]=79 [line]=16 [column]=1 [(ngModel)]='line10'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"line11"' [size]=79 [line]=17 [column]=1 [(ngModel)]='line11'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"line12"' [size]=79 [line]=18 [column]=1 [(ngModel)]='line12'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"line13"' [size]=79 [line]=19 [column]=1 [(ngModel)]='line13'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"line14"' [size]=79 [line]=20 [column]=1 [(ngModel)]='line14'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"line15"' [size]=79 [line]=21 [column]=1 [(ngModel)]='line15'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"line16"' [size]=79 [line]=22 [column]=1 [(ngModel)]='line16'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"msgln2"' [size]=79 [line]=23 [column]=1 [(ngModel)]='msgln2'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_08 col_01'><span class='default' id='text6'>PF3=EXIT</span>  </div>
  <div class='lgr_10 col_13'><span class='default' id='text7'>PF4=RETURN</span>  </div>
  <div class='lgr_12 col_27'><dynamic-field [id]='"frstkey"' [size]=12 [line]=24 [column]=27 [(ngModel)]='frstkey'></dynamic-field></div>
  <div class='lgr_12 col_43'><dynamic-field [id]='"scndkey"' [size]=12 [line]=24 [column]=43 [(ngModel)]='scndkey'></dynamic-field></div>
</div>
</div>
